import { Icon } from "@iconify/react/dist/iconify.js";
import { useSelector } from "react-redux";
import { getStoreId } from "../redux/selectors";

export const UpdatesBanner = () => {
  const storeId = useSelector(getStoreId);

  return (
    <div className="relative w-full h-14 lg:h-16 bg-red-600 text-mainWhite uppercase font-extrabold">
      <Icon
        icon="fxemoji:loudspeaker"
        className="absolute left-2 lg:left-20 top-1/4 text-2xl lg:text-3xl animate-pulse"
      />
      <h2 className="absolute left-10 right-10 lg:mt-4 text-xl drop-shadow-xl opacity-0 lg:text-4xl animate-rotate-words-1">
        Now delivering to Winnipeg & suburbs!
      </h2>
      <h2 className="absolute left-10 right-10 lg:mt-4 text-xl drop-shadow-xl opacity-0 lg:text-4xl animate-rotate-words-2">
        {storeId === "682b89f4c28a3e5c9c0ce409"
          ? "Free delivery for orders over $200"
          : storeId === "682b89f4c28a3e5c9c0ce408"
          ? "Ready-to-Eat Meals in Brandon"
          : "Choose your area below"}
      </h2>
      <h2 className="absolute left-10 right-10 lg:mt-4 text-xl drop-shadow-xl opacity-0 lg:text-4xl animate-rotate-words-3">
        {storeId === "682b89f4c28a3e5c9c0ce409"
          ? "72-hour delivery in Winnipeg & area"
          : "Call us or order online"}
      </h2>
      <Icon
        icon="fxemoji:loudspeaker"
        className="absolute right-2 lg:right-20 top-1/4 text-2xl lg:text-3xl animate-pulse [transform:_rotateY(180deg)] "
      />
    </div>
  );
};
